<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface Props {
  icon: string
  title: string
}

const props = defineProps<Props>();
</script>

<template>
  <div class="flex flex-col gap-6 p-4 bg-white rounded-3xl blue-shadow sm:!gap-8 sm:p-6">
    <div class="flex flex-col h-full gap-8">
      <div class="flex items-center gap-4">
        <FontAwesomeIcon
          data-test-id="card-icon"
          class="text-2xl md:!text-3xl"
          :icon="['fad', props.icon]"
        />
        <span
          data-test-id="card-title"
          class="text-intro-strong"
        >
          {{ props.title }}
        </span>
      </div>
      <div class="flex flex-col gap-6 size-full justify-between sm:!gap-8">
        <slot />
      </div>
    </div>
  </div>
</template>
